import React, { useState, useEffect } from 'react'
import ContactForm from '../components/ContactForm';
import { getContent } from "../middleware/contentFetch";
// import Form from '../components/Form';

const Contact = () => {
  const [content, setContent] = useState([]);

  useEffect(() => {
    getContent()
      .then(data => { setContent(data.contact || {}); })
      .catch(() => setContent({}));
  }, []);

  return (
    <div style={{"backgroundColor": "#f3e5f5"}}>
      <div className="container py-5" id='contact'>
        <div className="text-center mb-5">
          <h1 className="text-primary fw-bold">{content['page_title']}</h1>
          <p className="lead text-muted">{content['contact_tag']}</p>
        </div>

        <div className="row g-4">
          {/* Left Column - Contact Info & Map */}
          <div className="col-lg-6 mb-4 mb-lg-0">
            <div className="mb-4">
              <h2 className="text-primary mb-4">{content['sub_title']}</h2>

              <div className="card border-0 shadow-sm h-100">
                <div className="card-body">
                  <div className="mb-4">
                    <h5 className="fw-bold mb-3">{content['address_title']}</h5>
                    <p className="mb-1 fs-5">{content['address_line1']}</p>
                    <p className="mb-0 fs-5">{content['address_line2']}</p>
                  </div>
                  <hr />
                      <div className="mb-4">
                      <h5 className="fw-bold mb-3">{content['contact_title']}</h5>
                        <div className="row col-lg-12">
                          <p className="col-md-3 mb-0 fs-5">Phone: </p>
                          <div className="col-md-9 row">
                            <a href={`tel:${content['phone1']}`} className="fs-5 text-decoration-none">{content['phone1']}</a>
                            <a href={`tel:${content['phone2']}`} className="fs-5 text-decoration-none">{content['phone2']}</a>
                          </div>

                        </div>
                        <p className="mb-0 fs-5">Email: <a href={`mailto:${content['email']}`} className="text-decoration-none">{content['email']}</a></p>
                      </div>
                  <hr />
                </div>
              </div>
            </div>

            {/* Map Section */}
            <div>
              <h4 className="text-primary mb-3">{content['map_title']}</h4>
              <div className="ratio ratio-16x9">
                <iframe
                  src={content['map_iframe_link']}
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  title="Computer Shop Location">
                </iframe>
                {/* </div> */}
              </div>
            </div>
          </div>

          {/* Right Column - Contact Form */}
          <div className="col-lg-6">
            <div className="card border- shadow-sm h-100">
              <div className="card-body p-4 p-lg-3">
                <h2 className="text-primary mb-4">{content['form_title']}</h2>
                <p className="text-muted mb-4">{content['form_desc']}</p>
                {/* form body called */}
                <ContactForm />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact